import { currencyFormatter, textFormatter } from "../../../../utils/formatter/formatter";

export const buildOpportunitiesCardDataProductInfo = ({ t, opportunitiesTotal }) => ({
  title: t("product"),
  data: [
    {
      heading: t("totalOpportunities"),
      number: opportunitiesTotal != null && !isNaN(opportunitiesTotal)
        ? currencyFormatter.format(opportunitiesTotal)
        : t("waitingForData"),
      text: opportunitiesTotal != null && !isNaN(opportunitiesTotal) ? t("addingStockAndSales") : t("moreInformationSoon"),
      link: "",
    },
  ],
});

export const buildOpportunitiesCardDataChannelInfo = ({ t, opportunitiesTotal, waitingData }) => ({
  title: t("channels"),
  data: [
    {
      heading: t("totalOpportunities"),
      number: !waitingData
        ? currencyFormatter.format(opportunitiesTotal)
        : t("waitingForData"),
      text: !waitingData ? t("adjustingPlanAndStock") : t("moreInformationSoon"),
      link: "",
    },
  ],
});

export const buildProductCardData = ({
  t,
  unit,
  planVsForecast,
  percentDifference,
  difference
}) => {
  return {
    title: t("product"),
    data: [
      {
        heading: textFormatter(t("productPlan"), { textTransform: 'uppercase' }),

        number:
          planVsForecast && difference
            ? `${difference.arrow} ${
                unit === "items"
                  ? `${planVsForecast} pçs`
                  : `R$ ${planVsForecast}`
              }`
            : t("waitingForData"),

        text:
          percentDifference && difference
            ? `${percentDifference} ${difference.word} do Forecast`
            : t("moreInformationSoon"),

        link: "",
      },
    ],
  };
};

export const buildChannelCardData = ({ t, opportunitiesTotal, waitingData }) => ({
  title: t("channels"),
  data: [
    {
      heading: textFormatter(t("channelsTarget"), { textTransform: 'uppercase' }),
      number: !waitingData
        ? currencyFormatter.format(opportunitiesTotal)
        : t("waitingForData"),
      text: !waitingData ? t("belowForecast") : t("moreInformationSoon"),
      link: "",
    },
  ],
});